import { Link } from "react-router-dom";
import { Instagram, Facebook, MessageCircle, Mail } from "lucide-react";
import logoVerticalWhite from "@/assets/logo-vertical-white.webp";
import { useUserType } from "@/hooks/useUserType";

const Footer = () => {
  const { setType } = useUserType();
  return (
    <footer id="ayuda" className="bg-foreground text-background">
      <div className="container-custom mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Col 1 - Logo + Tagline + Social */}
          <div className="col-span-2 md:col-span-1">
            <img src={logoVerticalWhite} alt="Compaws" className="h-16 w-auto object-contain mb-4" loading="lazy" />
            <p className="font-poppins text-sm text-background/60 mb-5 leading-relaxed">
              Conectando mascotas<br />con personas que las aman.
            </p>
            <div className="flex gap-3">
              <a href="https://www.instagram.com/com.paws" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-background/10 rounded-full flex items-center justify-center hover:bg-orange transition-colors" aria-label="Instagram">
                <Instagram className="w-4 h-4 text-background" />
              </a>
              <a href="https://www.facebook.com/profile.php?id=61587056692438" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-background/10 rounded-full flex items-center justify-center hover:bg-orange transition-colors" aria-label="Facebook">
                <Facebook className="w-4 h-4 text-background" />
              </a>
              <a href="https://wa.me/50360651263" target="_blank" rel="noopener noreferrer" className="w-9 h-9 bg-background/10 rounded-full flex items-center justify-center hover:bg-orange transition-colors" aria-label="WhatsApp">
                <MessageCircle className="w-4 h-4 text-background" />
              </a>
              <a href="mailto:info@somoscompaws.com" className="w-9 h-9 bg-background/10 rounded-full flex items-center justify-center hover:bg-orange transition-colors" aria-label="Email">
                <Mail className="w-4 h-4 text-background" />
              </a>
            </div>
          </div>

          {/* Col 2 - Servicios */}
          <div>
            <h2 className="font-fredoka text-base mb-4 text-background">Servicios</h2>
            <ul className="space-y-2">
              {["Hospedaje", "Paseo", "Visita rápida", "Guardería", "Cuidado en casa"].map((s) => (
                <li key={s}>
                  <Link to="/buscar" className="font-poppins text-sm text-background/60 hover:text-orange transition-colors duration-200">
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3 - Compaws */}
          <div>
            <h2 className="font-fredoka text-base mb-4 text-background">Compaws</h2>
            <ul className="space-y-2">
              <li><a href="#como-funciona" className="font-poppins text-sm text-background/60 hover:text-orange transition-colors duration-200">Cómo funciona</a></li>
              <li><Link to="/registro" onClick={() => setType("compawdre")} className="font-poppins text-sm text-background/60 hover:text-orange transition-colors duration-200">Soy cuidador</Link></li>
              <li><Link to="/sobre-nosotros" className="font-poppins text-sm text-background/60 hover:text-orange transition-colors duration-200">Quiénes somos</Link></li>
            </ul>
          </div>

          {/* Col 4 - Ayuda */}
          <div>
            <h2 className="font-fredoka text-base mb-4 text-background">Ayuda</h2>
            <ul className="space-y-2">
              <li><Link to="/contacto" className="font-poppins text-sm text-background/60 hover:text-orange transition-colors duration-200">Centro de ayuda</Link></li>
              <li><Link to="/terminos" className="font-poppins text-sm text-background/60 hover:text-orange transition-colors duration-200">Términos y condiciones</Link></li>
              <li><Link to="/privacidad" className="font-poppins text-sm text-background/60 hover:text-orange transition-colors duration-200">Privacidad</Link></li>
              <li><Link to="/contacto" className="font-poppins text-sm text-background/60 hover:text-orange transition-colors duration-200">Contacto</Link></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-background/10">
        <div className="container-custom mx-auto px-4 md:px-8 py-5">
          <p className="font-poppins text-xs text-background/50 text-center">
            © 2026 Compaws — THKC, Sociedad por Acciones Simplificadas de Capital Variable. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
